import request from '../axios';

/**
 * 合作意向相关API接口
 */
const cooperationAPI = {
  /**
   * 提交合作意向
   * @param {Object} data - 合作意向数据
   * @param {string} data.name - 姓名
   * @param {string} data.company - 公司
   * @param {string} data.position - 职位
   * @param {string} data.phoneNumber - 手机号
   * @param {string} data.email - 邮箱
   * @param {string} data.cooperationIntention - 合作意向内容
   * @returns {Promise} - 返回Promise对象
   */
  submitCooperation(data) {
    return request({
      url: '/cooperation',
      method: 'POST',
      data
    });
  },

  /**
   * 获取合作意向列表（管理员用）
   * @param {Object} params - 查询参数
   * @param {number} params.page - 页码
   * @param {number} params.pageSize - 每页数量
   * @returns {Promise} - 返回Promise对象
   */
  getCooperationList(params) {
    return request({
      url: '/cooperation/list',
      method: 'GET',
      params
    });
  },

  /**
   * 获取合作意向详情（管理员用）
   * @param {string} id - 合作意向ID
   * @returns {Promise} - 返回Promise对象
   */
  getCooperationDetail(id) {
    return request({
      url: `/cooperation/${id}`,
      method: 'GET'
    });
  },

  /**
   * 删除合作意向（管理员用）
   * @param {string} id - 合作意向ID
   * @returns {Promise} - 返回Promise对象
   */
  deleteCooperation(id) {
    return request({
      url: `/cooperation/${id}`,
      method: 'DELETE'
    });
  }
};

export default cooperationAPI;